import styles from './Skeleton.module.css';

export function Skeleton({ width, height = '1em' }: { width: string; height?: string }) {
  return (
    <span
      className={styles.skeleton}
      style={{ width, height }}
      role="presentation"
      aria-hidden="true"
    />
  );
}
